import { render, staticRenderFns } from "./custdetail_details.vue?vue&type=template&id=dbbda8aa"
import script from "./custdetail_details.ts?vue&type=script&lang=js&external"
export * from "./custdetail_details.ts?vue&type=script&lang=js&external"
import style0 from "./custdetail_details.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports